export default __webpack_public_path__ + "static/media/lap_image1.4bc4a42a.jfif";